<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Announcement History</h5>
  </div>
<div id="mainContent" class="container">
    <div class="modal-body">
        <div class="row mt-3">
          <div class="col-md-5">
            <div class="row">
          <label class="col-md-3">From Date: </label>
          <div class="col-md-8">
            <div class="input-group">
              <input
                class="form-control form-control-xs"
                placeholder="dd/mm/yyyy"
                name="fromDate"
                (dateSelect)="onFromDateChange($event)"
                ngbDatepicker
                #fromDate="ngbDatepicker"
                [placement]="'bottom'"
               
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-theme calendar"
                  (click)="fromDate.toggle()"
                  type="button"
                ></button>
              </div>
            </div>
          </div>
        </div>
        </div>
    
        <div class="col-md-5">
          <div class="row">
        <label class="col-md-3">To Date: </label>
        <div class="col-md-8">
          <div class="input-group">
            <input
              class="form-control form-control-xs"
              placeholder="dd/mm/yyyy"
              (dateSelect)="onToDateChange($event)"
              name="toDate"
              ngbDatepicker
              [minDate]="convertFromDate"
              #toDate="ngbDatepicker"
              [placement]="'bottom'"
              
            />
            <div class="input-group-append">
              <button
                class="btn btn-outline-theme calendar"
                (click)="toDate.toggle()"
                type="button"
              ></button>
            </div>
          </div>
        </div>
      </div>
      </div>
    
      <div class="col-md-2">
        <button
        id="updatePersonalDetailsBtn"
        name="updatePersonalDetailsBtn"
        type="button"
        class="btn btn-sm btn-block btn-outline-theme"
        (click)="onClickViewDetails()"
      >
        View Details
      </button>
      </div>
    </div>
    
    <div class="mt-3" *ngIf="announcementHistoryList.length>0">
      <table class="table table-striped table-bordered">
        <thead style="background-color: lightskyblue">
          <tr>
            <th scope="col" width="15%">Announcement</th>
            <th scope="col" width="15%">Created Date</th>
            <th scope="col" width="70%">Details</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of announcementHistoryList">
            <td width="15%">{{ data.announcementName }}</td>
            <td width="15%">{{ data.createdDate | date: "dd-MMMM-yyyy"}}</td>
            <td width="70%" style="white-space: pre-wrap">
             <div [innerHTML]="data.announcementDetails"></div>
                 <a
                href="{{ data.announcementUrl }}"
                target="_blank"
                rel="noopener noreferrer"
              >{{data.announcementUrl}}
              </a>
            
              <tr *ngIf="data.url != null">
                <td
                  *ngIf="
                    data.fileType == 'jpg' ||
                      data.fileType == 'jpeg' ||
                      data.fileType == 'png';
                    else other_content
                  "
                >
                  <img
                    [src]="data.url"
                    style="display: block; width: 100%; height: auto"
                  />
                </td>
                <ng-template #other_content>
                  <td>
                    <a
                      href="{{ data.url }}"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i class="fa fa-download fa-3x" aria-hidden="true"></i>
                      <br />
                    </a>
                    <span>{{ data.imageName }}</span>
                  </td>
                </ng-template>
              </tr>
            </td>
          </tr>
          <tr *ngIf="announcementHistoryList.length == 0">
            <td colspan="2" style="text-align: center">
              No Announcement Available
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
      </div>

</div>
</div>